import { useContext, createContext } from "react";
import type { ListboxContextValue } from "./types";

// 创建 Listbox 上下文
export const ListboxContext = createContext<ListboxContextValue>({});

// 使用 Listbox 上下文的 Hook
export const useListboxContext = () => useContext(ListboxContext);